export default __webpack_public_path__ + "static/media/Layer_2@2x.c96d9d6d.png";